import { Controller } from '@hotwired/stimulus';
import { Helpers } from '../helpers';

export default class InvestmentSimulatorController extends Controller {
  static targets = [
    'slider',
    'input',
    'rentalIncome',
    'capitalProjection',
    'resultCard',
  ];

  static values = {
    minInvestment: { type: Number, default: 100 },
    maxInvestment: { type: Number, default: 800000 },
    targetedProfitability: { type: Number },
    investmentDuration: { type: Number, default: 8 },
  }

  connect() {
    this.calculate();
  }

  updateFromSlider() {
    const value = this.sliderTarget.value;
    this.inputTarget.value = this.formatNumber(value);
    this.calculate();
  }

  updateFromInput() {
    const clampedValue = this.clampInvestmentValue();

    this.sliderTarget.value = clampedValue;
    this.calculate();
  }

  formatInput() {
    const clampedValue = this.clampInvestmentValue();

    this.inputTarget.value = this.formatNumber(clampedValue);
    this.sliderTarget.value = clampedValue;
  }

  calculate() {
    const investment = parseFloat(this.sliderTarget.value) || 0;

    if (investment <= 0) {
      this.rentalIncomeTarget.textContent = '- €';
      this.capitalProjectionTarget.textContent = '- €';
      this.updateResultCardStyles(false);
      return;
    };

    const totalRentalIncome =
      investment * (this.targetedProfitabilityValue / 100) * (this.investmentDurationValue / 12);
    const capitalProjection = investment + totalRentalIncome;

    this.rentalIncomeTarget.textContent = Helpers.numberToCurrency(totalRentalIncome, 2);
    this.capitalProjectionTarget.textContent = Helpers.numberToCurrency(capitalProjection, 2);
    this.updateResultCardStyles(true);
  }

  clampInvestmentValue() {
    const rawValue = this.inputTarget.value.replace(/\s/g, '').replace(',', '.');
    const value = parseFloat(rawValue) || 0;

    return Math.min(Math.max(value, this.minInvestmentValue), this.maxInvestmentValue);
  }

  formatNumber(value) {
    return new Intl.NumberFormat('fr-FR').format(Math.round(value));
  }

  updateResultCardStyles(hasValue) {
    this.resultCardTargets.forEach(card => {
      card.classList.toggle('bg-primary-100', hasValue);
      card.classList.toggle('bg-gray-50', !hasValue);
    });
  }
}
